export default {
  labels: {
    open: 'Vis varer',
    collapse: 'Skjul varer',
    in_stock: 'På lager',
    out_of_stock: 'Udsolgt',
  },
  list: {
    name: 'Menupunkt',
    price: 'Pris',
    is_available: 'PÅ LAGER/UDSOLGT',
  },
};
